/* 🤖 this file was generated by svg-to-ts */
export const myIconChevronForward: {
  name: 'chevron_forward';
  data: string;
} = {
  name: 'chevron_forward',
  data: `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="m184 112 144 144-144 144"/></svg>`,
};
